<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div v-show="!viewingDetailsId">
			<div class="widget-location">
				<h3>쿠팡 발송 신청/결제</h3>
			</div>
		<div class="list-top">
			<div class="">
				<span>전체 : <strong>{{total}}</strong> ( {{current_page}} / {{last_page}} 페이지 )</span>
			</div>
		</div>
		
		<el-table
		  :data="tableData" empty-text="데이터가 없습니다"
		  stripe 
		  style="width: 100%; cursor: pointer;">
			<el-table-column
			  v-if="!isMobile"
			  prop="delivery_center_code" 
			  label="배송방법"
			  width="100">
			</el-table-column>
			<el-table-column
			  v-if="!isMobile"
			  prop="customs_type"
			  label="통관방법" width="100">
			</el-table-column>
			<el-table-column label="신청 상세 정보" min-width="320">
			  <template slot-scope="scope">
				<div class="agency-info-row">
				  <!-- 1. 주문번호 -->
				  <div class="info-badge">
					<span class="badge-label">주문번호</span>
					<span class="badge-value">{{ scope.row.platform_order_no || '-' }}</span>
				  </div>
				  <!-- 2. 수취인명 -->
				  <div class="info-badge">
					<span class="badge-label">수취인명</span>
					<span class="badge-value">{{ scope.row.realname || '-' }}</span>
				  </div>
				  <!-- 3. 상품 총 금액 -->
				  <div class="info-badge">
					<span class="badge-label">총 금액</span>
					<span class="badge-value" style="color: #ff5700; font-weight: bold;">{{ scope.row.total_amount }}</span>
				  </div>
				  <!-- 4. 상태 -->
				  <div class="info-badge">
					<span class="badge-label">상태</span>
					<span class="badge-value" style="color: #409eff; font-weight: bold;">{{ scope.row.status }}</span>
				  </div>
				  <!-- 5. 작성일 -->
				  <div class="info-badge" v-if="!isMobile">
					<span class="badge-label">작성일</span>
					<span class="badge-value">{{ scope.row.createtime_format }}</span>
				  </div>
				</div>
			  </template>
			</el-table-column>
			<el-table-column label="메뉴" width="240">
				<template slot-scope="scope">
					<!-- 其他位置可放置必要的操作按钮，例如“查看详情” -->
					<div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
						<el-button plain v-if="scope.row.audit_status == 0" size="mini" icon="el-icon-edit" @click="handleEditPacking(scope.row.id)">수정</el-button>
						<el-button size="mini" plain type="primary" icon="el-icon-view" @click="handleDetails(scope.$index, scope.row)">보기</el-button>
						<el-button v-if="scope.row.status_raw >= 23" size="mini" plain type="warning" icon="el-icon-coin" @click="handleViewFees(scope.row)">운임</el-button>
						<el-button v-if="scope.row.status_raw >= 26 && scope.row.status_raw <= 29" size="mini" plain type="primary" icon="el-icon-truck" @click="handleTracking(scope.row)">국제 배송조회</el-button>				
					</div>
				</template>
			</el-table-column>
		</el-table>
		
		<div class="page">
			<el-pagination
				layout="prev, pager, next" :page-size="20"
				:total="total"  @current-change="handleCurrentChange">
			</el-pagination>
		</div>
		<el-dialog title="운임 상세 내역" :visible.sync="feeDialogVisible" width="400px" custom-class="fee-dialog" center>
			<div v-if="selectedFeeInfo" class="fee-card">
				<!-- <div class="fee-section">
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-odometer"></i> 실제 중량</span>
						<span class="fee-value">{{ selectedFeeInfo.actual_weight || 0 }} kg</span>
					</div>
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-box"></i> 부피 중량</span>
						<span class="fee-value">{{ selectedFeeInfo.volume_weight || 0 }} kg</span>
					</div>
					<div class="fee-row highlight-row">
						<span class="fee-label"><i class="el-icon-truck"></i> 적용 중량</span>
						<span class="fee-value">{{ selectedFeeInfo.calc_weight || 0 }} kg</span>
					</div>
				</div>
				<div class="fee-divider"></div> -->

				<div class="fee-section">
					<div class="fee-row">
						<span class="fee-label">기본 운임</span>
						<span class="fee-value">₩ {{ selectedFeeInfo.shipping_fee || 0 }}</span>
					</div>
					<div class="fee-row">
						<span class="fee-label">부가 운임</span>
						<span class="fee-value">₩ {{ selectedFeeInfo.surcharge_fee || 0 }}</span>
					</div>
				</div>
				
				<div class="fee-divider dashed"></div>

				<div class="fee-row total-row">
					<span class="fee-label"><i class="el-icon-wallet"></i> 총 운임</span>
					<span class="fee-value total-amount">₩ {{ selectedFeeInfo.total_fee || 0 }}</span>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" style="display: flex; flex-direction: column; gap: 10px;">
				<div v-if="selectedFeeInfo && (selectedFeeInfo.status_raw == 23)" style="text-align: center; font-size: 16px; font-weight: bold; margin-bottom: 5px;">
					결제 금액: <span style="color: #f56c6c; font-size: 20px;">₩ {{ getPaymentAmount(selectedFeeInfo) }}</span>
				</div>
				<el-button v-if="selectedFeeInfo && (selectedFeeInfo.status_raw == 23)" type="warning" round size="medium" @click="handlePayment(selectedFeeInfo)" style="width: 100%; margin: 0;">결제하기</el-button>
				<el-button type="primary" round size="medium" @click="feeDialogVisible = false" style="width: 100%; margin: 0;">닫기</el-button>
			</span>
		</el-dialog>
		</div>

		<!-- 국제 배송조회 다이얼로그 -->
		<el-dialog title="국제 배송조회" :visible.sync="trackingDialogVisible" width="430px" custom-class="fee-dialog" center>
			<div v-if="trackingInfo" class="fee-card">
				<div class="fee-section">
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-truck"></i> 국제 택배 송장번호</span>
						<span class="fee-value" style="color: #409eff; font-weight: bold;">{{ trackingInfo.tracking_no || '-' }}</span>
					</div>
					<div class="fee-divider"></div>
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-time"></i> 발송 시간</span>
						<span class="fee-value">{{ trackingInfo.dispatchtime || '-' }}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" round @click="trackingDialogVisible = false">확인</el-button>
			</span>
		</el-dialog>

		<!-- 상세 정보 뷰 详细信息视图 (Detail Info View) -->
		<div v-if="viewingDetailsId && detailInfo" style="padding: 20px 0;" v-loading="detailLoading">
			<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; border-bottom: 2px solid #ebeef5; padding-bottom: 16px;">
				<h4 style="margin: 0; font-size: 20px; font-weight: bold; color: #303133;">재고 신청 상세 정보 (주문번호: {{detailInfo.platform_order_no || detailInfo.id}})</h4>
				<div style="display: flex; gap: 10px; align-items: center;">
					<el-button v-if="detailInfo.audit_status == 0" size="medium" style="color: #409EFF; border-color: #409EFF;" round @click="handleEditPacking(detailInfo.id)">수정</el-button>
					<el-button type="primary" size="medium" icon="el-icon-back" round @click="closeDetails">목록으로 돌아가기</el-button>
				</div>
			</div>

			<div style="min-height: 400px;">
				<el-descriptions title="기본 신청 정보" direction="vertical" :column="isMobile ? 2 : 4" border style="margin-bottom: 24px;">
				  <el-descriptions-item label="배송방법">
					  <div v-if="detailInfo.delivery_center_code == 'CN_SHIP' || detailInfo.delivery_center_code == '해운'" >해상</div>
					  <div v-else-if="detailInfo.delivery_center_code == 'CN_AIR' || detailInfo.delivery_center_code == '항공'" >항공</div>
					  <div v-else-if="detailInfo.delivery_center_code == 'CN_LCL' || detailInfo.delivery_center_code == '화물'" >LCL화물</div>
					  <div v-else >{{detailInfo.delivery_center_code}}</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="통관방법">
					  <div v-if="detailInfo.customs_type == '1' || detailInfo.customs_type == '간이통관'" style="color:#409eff;">간이통관</div>
					  <div v-else-if="detailInfo.customs_type == '2' || detailInfo.customs_type == '목록통관'" style="color:#67c23a;">목록통관</div>
					  <div v-else-if="detailInfo.customs_type == '3' || detailInfo.customs_type == '사업자통관'" style="color:#67c23a;">사업자통관</div>	
					  <div v-else >{{detailInfo.customs_type}}</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="회원명">{{detailInfo.username || detailInfo.nickname}}</el-descriptions-item>
				  <el-descriptions-item label="상품 총 금액">{{detailInfo.total_amount}}</el-descriptions-item>
				  <el-descriptions-item label="수취인명">{{detailInfo.realname}}</el-descriptions-item>
				  <el-descriptions-item label="우편번호">{{detailInfo.zipcode}}</el-descriptions-item>
				  <el-descriptions-item label="핸드폰">{{detailInfo.mobile}}</el-descriptions-item>
				  <el-descriptions-item label="개인통관고유부호">{{detailInfo.customs_info}}</el-descriptions-item>
				  <el-descriptions-item label="주소" :span="2">{{detailInfo.address}} {{detailInfo.detailed_address}}</el-descriptions-item>
				  <el-descriptions-item label="국내 택배사 요청사항">{{detailInfo.delivery_message}}</el-descriptions-item>
				  <el-descriptions-item label="관리코드">{{detailInfo.refer_code}}</el-descriptions-item>
				  <el-descriptions-item label="검토 상태">
					  <div v-if="detailInfo.status_raw == '0' || detailInfo.status == '0'" style="color:#409eff; font-weight: bold;">{{detailInfo.status}}</div>
					  <div v-else-if="detailInfo.status_raw == '1' || detailInfo.status == '1'" style="color:#67c23a; font-weight: bold;">{{detailInfo.status}}</div>
					  <div v-else-if="detailInfo.status_raw == '2' || detailInfo.status == '2'" style="color:#f56c6c; font-weight: bold;">{{detailInfo.status}}</div>	
					  <div v-else>{{detailInfo.status}}</div>
				  </el-descriptions-item>
				</el-descriptions>
				
				<div style="font-weight: bold; font-size: 15px; margin-bottom: 12px; color: #303133; padding-left: 4px; border-left: 4px solid #409eff;">신청 상품 정보</div>
				<el-descriptions v-for="(item,index) in detailInfo.goods" :key="index" style="margin-bottom:20px" :title="item.goods_name" direction="vertical" :column="isMobile ? 2 : 4" border size="small">
					<el-descriptions-item label="상품 이미지" >
						<el-popover placement="right" trigger="hover" v-if="item.goods_image">
							<el-image 
								style="width: 150px; height: 150px" 
								:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image" 
								fit="contain">
							</el-image>
							<el-image slot="reference"
								style="width: 50px; height: 50px; cursor: pointer; border-radius: 4px;"
								:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image"
								fit="cover">
							</el-image>	
						</el-popover>
					</el-descriptions-item>
					<el-descriptions-item label="상품코드">{{item.code}}</el-descriptions-item>
					<el-descriptions-item label="상품명">{{item.goods_name}}</el-descriptions-item>
					<el-descriptions-item label="수량">{{item.num}}</el-descriptions-item>
					<el-descriptions-item label="단가">{{item.price}}</el-descriptions-item>
					<el-descriptions-item label="색상">{{item.color}}</el-descriptions-item>
					<el-descriptions-item label="사이즈">{{item.size}}</el-descriptions-item>
					<el-descriptions-item label="바코드">{{item.barcode}}</el-descriptions-item>
					<el-descriptions-item label="택배 번호">{{item.tracking_no}}</el-descriptions-item>
					<el-descriptions-item label="상품 URL">
						<a :href="item.url" target="_blank" style="color: #409eff; text-decoration: none;">링크 보기</a>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return {
				total:0,
				page:1,
				current_page:1,
				last_page:1,
				tableData: [],
				feeDialogVisible: false,
				selectedFeeInfo: null,
				loading: true,
				viewingDetailsId: null,
				detailLoading: false,
				detailInfo: null,
				trackingDialogVisible: false,
				trackingInfo: null,
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			handleTracking(row) {
				request.post('/member/Inventory/getOutboundTracking', { id: row.id }).then(res => {
					if (res.code == 1) {
						this.trackingInfo = res.data;
						this.trackingDialogVisible = true;
					} else {
						this.$message.error(res.msg || '해당 정보가 없습니다.');
					}
				});
			},
			handleDetails(index, row) {
				this.viewingDetailsId = row.id;
				this.detailLoading = true;
				request.post('/member/Inventory/inventoryDetail', {
					id: row.id
				}).then(res => {
					this.detailLoading = false;
					if (res.code == 1) {
						this.detailInfo = res.data;
					} else {
						this.$message.error(res.msg || '상세 정보를 불러올 수 없습니다.');
						this.viewingDetailsId = null;
					}
				}).catch(() => {
					this.detailLoading = false;
					this.$message.error('네트워크 오류가 발생했습니다.');
					this.viewingDetailsId = null;
				});
			},
			closeDetails() {
				this.viewingDetailsId = null;
				this.detailInfo = null;
			},
			handleEditPacking(id) {
				this.$router.push({
					path: '/inventoryPackingEdit',
					query: { id: id }
				});
			},
			handleViewFees(row) {
				this.selectedFeeInfo = row;
				this.feeDialogVisible = true;
			},
			getPaymentAmount(info) {
				if (!info) return 0;
				// 库存列表仅考虑 agency_type == 1 的情况
				return Number(info.total_fee) || 0;
			},
			handlePayment(row) {
				const amount = this.getPaymentAmount(row);
				this.$confirm(`현재 표시된 금액(₩ ${amount})으로 결제를 진행하시겠습니까?`, '결제 확인', {
					confirmButtonText: '확인',
					cancelButtonText: '취소',
					type: 'warning'
				}).then(() => {
					// 请在此处提交实际付款申请。
					request.post('/member/Paymentorder/payment', {
						id: row.id,
						source_type:'inventory',//库存
						
					}).then(res => {
						if (res.code == 1) {
							this.$message.success('결제가 완료되었습니다.');
							this.feeDialogVisible = false;
							this.getList(); 
						} else {
							this.$message.error(res.msg || '결제에 실패했습니다.');
						}
					}).catch(err => {
						console.error(err);
						this.$message.error('서버 오류가 발생했습니다.');
					});
				}).catch(() => {
					// 取消操作（无）
				});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			getList(){
				this.loading = true
				request.post('/member/Inventory/inventoryList',
					{
						page:this.page,	
					}
				).then(res => {
					this.loading = false
					console.log(res,"inventoryList")
					if(res.code ==1){
						this.total = res.data.total || 0
						this.current_page = res.data.current_page || 1
						this.last_page = res.data.last_page || 1
						this.tableData= res.data.data || []
					}	
				}).catch(() => {
					this.loading = false
				});
				
			},
		}
		
		
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
		padding:0 10px;
	}
	
	.page{
		padding-top: 20px;
		text-align: center;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: var(--background-color);
	}
	::v-deep .el-pagination button:disabled {
		background-color: var(--background-color);
	}
	::v-deep .el-pagination .btn-next,::v-deep .el-pagination .btn-prev {
	    background: center center no-repeat var(--background-color);
	}
	
	.fee-card {
		background: #f8f9fc;
		border-radius: 8px;
		padding: 20px;
		box-shadow: inset 0 0 4px rgba(0,0,0,0.05);
	}
	.fee-section {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	.fee-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		color: #606266;
	}
	.fee-label {
		display: flex;
		align-items: center;
		gap: 6px;
	}
	.fee-value {
		font-weight: 600;
		color: #303133;
	}
	.highlight-row {
		background: #eef5fe;
		padding: 8px 12px;
		border-radius: 6px;
		margin: -8px -12px;
		color: #409EFF;
	}
	.highlight-row .fee-value {
		color: #409EFF;
	}
	.fee-divider {
		height: 1px;
		background: #ebeef5;
		margin: 20px 0;
	}
	.fee-divider.dashed {
		border-top: 1px dashed #dcdfe6;
		background: transparent;
	}
	.total-row {
		font-size: 16px;
		color: #303133;
		font-weight: bold;
	}
	.total-amount {
		font-size: 20px;
		color: #f56c6c;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		
		.page{
			padding-bottom: 20px;
		}
		
	}
	.agency-info-row {
	    display: flex;
	    flex-wrap: wrap;
	    gap: 8px;
	    align-items: center;
	    padding: 4px 0;
	}
	.info-badge {
	    display: inline-flex;
	    align-items: center;
	    border: 1px solid #dcdfe6;
	    border-radius: 6px;
	    overflow: hidden;
	    font-size: 12px;
	    background: #fff;
	    line-height: 1.4;
	    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
	}
	.badge-label {
	    background: #f5f7fa;
	    color: #606266;
	    padding: 5px 10px;
	    border-right: 1px solid #dcdfe6;
	    font-weight: bold;
	    white-space: nowrap;
	}
	.badge-value {
	    padding: 5px 12px;
	    color: #303133;
	    white-space: nowrap;
	}
</style>
